export const LogoBolt = (props) => (
  <svg
    width={39}
    height={22}
    viewBox="0 0 39 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_11275_169468)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.6523 0.500005V16.2887H26.8688V1.28944L30.6523 0.500005ZM19.8797 17.785C20.9245 17.785 21.7715 18.6166 21.7715 19.6425C21.7715 20.6683 20.9245 21.5 19.8797 21.5C18.8349 21.5 17.9879 20.6683 17.9879 19.6425C17.9879 18.6166 18.8349 17.785 19.8797 17.785ZM19.8797 4.98378C23.101 4.98378 25.718 7.54818 25.718 10.7162C25.718 13.8843 23.101 16.4487 19.8797 16.4487C16.6532 16.4487 14.0415 13.8843 14.0415 10.7162C14.0415 7.54818 16.6584 4.98378 19.8797 4.98378ZM19.8797 12.5737C20.9254 12.5737 21.7715 11.743 21.7715 10.7162C21.7715 9.68944 20.9254 8.85874 19.8797 8.85874C18.834 8.85874 17.9879 9.68944 17.9879 10.7162C17.9879 11.743 18.834 12.5737 19.8797 12.5737ZM7.97731 12.5737C8.62891 12.5737 9.15967 12.0526 9.15967 11.4128C9.15967 10.773 8.62891 10.2518 7.97731 10.2518H5.13963V12.5737H7.97731ZM5.13963 4.21499V6.53687H7.24161C7.89321 6.53687 8.42397 6.0157 8.42397 5.37592C8.42397 4.73612 7.89321 4.21499 7.24161 4.21499H5.13963ZM11.4613 7.9403C12.3757 8.82776 12.9432 10.0558 12.938 11.4128C12.938 14.1062 10.7152 16.2887 7.97206 16.2887H1.35083V0.5H7.23636C9.97946 0.5 12.2023 2.68256 12.2023 5.37592C12.2023 6.315 11.9343 7.19732 11.4613 7.9403ZM37.799 8.91034H35.9126V11.8256C35.9126 12.7079 36.2016 13.358 36.9582 13.358C37.447 13.358 37.8043 13.2496 37.8043 13.2496V15.9843C37.8043 15.9843 37.0213 16.4487 35.9598 16.4487H35.9126C35.8652 16.4487 35.8232 16.4435 35.7759 16.4435H35.7391C35.7181 16.4435 35.6918 16.4383 35.6708 16.4383C33.5583 16.33 32.1237 15.0245 32.1237 12.7595V3.14693L35.9073 2.35749V5.19533H37.799V8.91034Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_11275_169468">
        <rect
          width={38}
          height={21}
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
